export const ASSESSMENT_TYPES = [
  { value: "prima_emissione", label: "Prima emissione" },
  { value: "sorveglianza", label: "Sorveglianza" },
  { value: "rinnovo", label: "Rinnovo" },
  { value: "estensione", label: "Estensione" },
];

export const ASSESSMENT_TYPE_LABEL = Object.fromEntries(ASSESSMENT_TYPES.map((t) => [t.value, t.label]));
